import {Divider} from '@/components/ui/divider/Divider'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {ExtendsCycleProjectFormProvider} from '@/features/projects/components/project-form/extends-cycle-project-form-provider/ExtendsCycleProjectFormProvider'
import {ExtendsCycleProjectFormSections} from '@/features/projects/components/project-form/extends-cycle-project-form-sections/ExtendsCycleProjectFormSections'
import {ProjectFormHeading} from '@/features/projects/components/project-form/project-form-heading/ProjectFormHeading'
import {ExtendsProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {useGetHolidays} from '@/features/projects/queries/useGetHolidays'
import {ProjectExtended} from '@/features/projects/types'
import {useTranslation} from '@/translations/i18n'
import {useDialogStore} from '@ariakit/react'
import dayjs from 'dayjs'
import {useState} from 'react'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {ExtendsCycleConfirmationModal} from '@/features/projects/components/exteds-cycle-confirmation-modal/ExtendsCycleConfirmationModal'

export const ProjectExtendsCycle = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
    const confirmationModalStore = useDialogStore({
        open: isConfirmationModalOpen,
        setOpen: setIsConfirmationModalOpen
    })
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {data: holidays} = useGetHolidays({urlParams: {year: dayjs(project.expirationDate).year()}})

    if (!permissions?.projects.write) {
        return <NoPermissionBox />
    }

    return (
        <PageCardWrapper>
            <Helmet title={t('projects:extends_cycle_meta_title')} />
            <ExtendsCycleProjectFormProvider project={project} holidays={holidays || []}>
                <ProjectFormHeading
                    title={t('projects:extends_cycle_title')}
                    schema={ExtendsProjectFormValidationSchema}
                    showConfirmationModal={() => confirmationModalStore.setOpen(true)}
                />
                <Divider direction="horizontal" />
                <PageContent padding={0}>
                    <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                        <ExtendsCycleProjectFormSections isExtendable={project.type == 'cyclic'} />
                    </ScrollArea>
                </PageContent>
                {isConfirmationModalOpen && (
                    <ExtendsCycleConfirmationModal projectId={project.id} dialogStore={confirmationModalStore} />
                )}
            </ExtendsCycleProjectFormProvider>
        </PageCardWrapper>
    )
}
